import axios from "axios";
import JwtService from "@/core/services/jwt.service";
import store from "@/core/services/store";
import router from "@/router";
import { PURGE_AUTH } from "@/core/services/store/auth.module";

export default function setup() {
  axios.interceptors.request.use(
    function (config) {
      const proxyPath = ["/customer"];
      const isProxy = config.url.includes(proxyPath);

      // Check if token is expired before making request
      if (JwtService.isTokenExpired() && !config.url.includes("/login")) {
        // Token is expired, clear it and redirect to login
        store.commit(PURGE_AUTH);
        if (router.currentRoute.name !== "login") {
          router.push({ name: "login" });
        }
        return Promise.reject(new Error("Token expired"));
      }

      config.headers = {
        Authorization: `Bearer ${JwtService.getToken()}`,
        Accept: "application/json",
      };
      if (!isProxy) {
        const payloadMethods = ["put", "post", "delete"];
        if (
          config.data &&
          !config.data.json &&
          !config.headers["Content-Type"]
        ) {
          if (payloadMethods.includes(config.method)) {
            config.headers["Content-Type"] =
              "application/x-www-form-urlencoded";
          }
        } else {
          config.headers["Content-Type"] = "application/json";
          if (config.data && config.data.json) delete config.data.json;
        }
      }
      return config;
    },
    function (error) {
      // Do something with request error
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    function (response) {
      return response.data;
    },
    function (err) {
      // Handle token expiration
      if (err.response && err.response.status === 401) {
        // Check if we're not already on the login page to prevent infinite redirects
        if (router.currentRoute.name !== "login") {
          // Clear authentication data
          store.commit(PURGE_AUTH);

          // Show token expiration message
          if (store.state.app && store.state.app.$bvToast) {
            store.state.app.$bvToast.toast(
              "Your session has expired. Please login again.",
              {
                title: "Session Expired",
                variant: "warning",
                solid: true,
                autoHideDelay: 5000,
              }
            );
          }

          // Redirect to login page
          router.push({ name: "login" }).catch(() => {
            // Handle potential navigation errors
          });
        }
      }
      return Promise.reject(err);
    }
  );
}
